import {useEffect} from 'react'
import TableFooter from 'src/components/table/components/tableFooter/TableFooter'
import LoadingTableRow from './components/loadingTableRow'
import TableHeader from './components/tableHeader/TableHeader'
import {TableComponent, TableContainer} from './TableBase'
import {TableProps} from './TableProps'

function Table({
  width,
  height,
  margin,
  padding,
  columns,
  isLoading,
  loadingDataHeight,
  skeletonRowsAmount,
  isOpenAdvancedSearch,
  onAdvancedSearch,
  onCloseAdvancedSearch,
  children,
  tableHeaderChildren,
  tableBodyProps,
  footer,
  ...headerProps
}: TableProps) {
  const loadingArray = new Array(skeletonRowsAmount ?? 5).fill(1)

  function handleColumns() {
    return columns[columns.length - 1].id.trim().length !== 0 && onCloseAdvancedSearch ? [...columns, {id: '', name: ''}] : columns
  }

  useEffect(() => {
    if (!isOpenAdvancedSearch && onAdvancedSearch) onAdvancedSearch(null)
  }, [isOpenAdvancedSearch])

  return (
    <TableContainer width={width} height={height} margin={margin} padding={padding}>
      <TableComponent>
        {tableHeaderChildren ?? <TableHeader columns={handleColumns()} {...headerProps} />}
        {tableBodyProps ?? (
          <tbody>
            {isLoading
              ? loadingArray.map((_, index) => <LoadingTableRow key={index} columns={handleColumns()} loadingDataHeight={loadingDataHeight} />)
              : children}
          </tbody>
        )}
        {footer && (
          <>
            <tr style={{height: '20px'}}></tr>
            <tfoot>
              <TableFooter columns={footer} {...headerProps} />
            </tfoot>
          </>
        )}
      </TableComponent>
    </TableContainer>
  )
}

export default Table
